import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { environment } from '@app/env-service';

@Injectable({
  providedIn: 'root',
})
export class CardNotesService {
  url :string = environment.url;

  constructor(private http :HttpClient) {}

  saveNote(designId :number, payload :any) :Observable<any> {
    return this.http.post(
      `${this.url}/product_designs/${designId}/save-comment`,
      payload,
    );
  }

  deleteAttachment(designId :number, payload :any) :Observable<any> {
    return this.http.post(
      `${this.url}/product_designs/${designId}/delete-comment-attachment`,
      payload,
    );
  }

  deleteComment(designId :number, payload :any) :Observable<any> {
    return this.http.post(
      `${this.url}/product_designs/${designId}/delete-comment`,
      payload,
    );
  }

  getCommentTabsByDesignId(designId :number) :Observable<any> {
    return this.http.get(`${this.url}/product_designs/${designId}/comment-tab`);
  }

  saveCommentTab(designId :number, payload :any) :Observable<any> {
    return this.http.post(
      `${this.url}/product_designs/${designId}/comment-tab`,
      payload,
    );
  }

  deleteCommentTab(tabId :number) :Observable<any> {
    return this.http.delete(`${this.url}/product_designs/comment-tab/${tabId}`);
  }
}
